import {
  MANAGER_PERSONAL_INFO_FAIL,
  MANAGER_PERSONAL_INFO_REQUEST,
  MANAGER_PERSONAL_INFO_SUCCESS,
  GET_MANAGER_PERSONAL_INFO_FAIL,
  GET_MANAGER_PERSONAL_INFO_REQUEST,
  GET_MANAGER_PERSONAL_INFO_SUCCESS,
} from '../../types/manager/personalInfoTypes';

export const managerPersonalReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case MANAGER_PERSONAL_INFO_REQUEST:
      return {
        ...state,
        personalManagerLoading: true,
      };
    case MANAGER_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        personalManagerLoading: false,
        ManagerPersonalInfo: payload,
        personalManagerError: '',
      };
    case MANAGER_PERSONAL_INFO_FAIL:
      return {
        ...state,
        personalManagerLoading: false,
        ManagerPersonalInfo: [],
        personalManagerError: payload,
      };
    default:
      return state;
  }
};

export const getManagerPersonalReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MANAGER_PERSONAL_INFO_REQUEST:
      return {
        ...state,
        getPersonalManagerLoading: true,
      };
    case GET_MANAGER_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        getPersonalManagerLoading: false,
        getManagerPersonalInfo: payload,
        getPersonalManagerRError: '',
      };
    case GET_MANAGER_PERSONAL_INFO_FAIL:
      return {
        ...state,
        getPersonalManagerLoading: false,
        getManagerPersonalInfo: [],
        getPersonalManagerError: payload,
      };
    default:
      return state;
  }
};
